import { render, staticRenderFns } from "./AuthDataTree.vue?vue&type=template&id=55f2aaa6&"
import script from "./AuthDataTree.vue?vue&type=script&lang=js&"
export * from "./AuthDataTree.vue?vue&type=script&lang=js&"
import style0 from "./AuthDataTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports